import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetFormularioPECATAByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetFormularioPECATAByUser = () => {
  const [loadingGetFormularioPECATAByUser, setLoadingGetFormularioPECATAByUser] = useState(false);
  const [successGetFormularioPECATAByUser, setSuccessGetFormularioPECATAByUser] = useState(false);
  const [errorGetFormularioPECATAByUser, setErrorGetFormularioPECATAByUser] = useState<any>(null);
  const [dataGetFormularioPECATAByUser, setDataFormularioPECATAByUser] = useState<any>(null);

  const [statusGetFormularioPECATAByUser, setStatusGetFormularioPECATAByUser] =
    useState<StatusGetFormularioPECATAByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getFormularioPECATAByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetFormularioPECATAByUser(true);
    setSuccessGetFormularioPECATAByUser(false);
    setErrorGetFormularioPECATAByUser(null);

    try {
      const res = await apirecord.getSolicitudPecataByUser(userId, expedienteId);

      setStatusGetFormularioPECATAByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetFormularioPECATAByUser(true);
      setDataFormularioPECATAByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetFormularioPECATAByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetFormularioPECATAByUser(err);
      console.error("Error en getFormularioPECATAByUser:", err);

      throw err;

    } finally {
      setLoadingGetFormularioPECATAByUser(false);
    }
  };

  return {
    getFormularioPECATAByUser,
    loadingGetFormularioPECATAByUser,
    successGetFormularioPECATAByUser,
    errorGetFormularioPECATAByUser,
    dataGetFormularioPECATAByUser,
    statusGetFormularioPECATAByUser
  };
};

export default useGetFormularioPECATAByUser;
